export class InventoryDetails {
    customerItemId: number;
    customerItem: string;
    description: string;
    purchaseUOM: string;
    packSize: number;
    packUOM: string;
    qty: number;
    price: number;
    catchWeight: string;
    ledgerCode: string;
    charges: number;
    genericItem: string;
    genericQty: number;
    amount: number;
    uomPackSize: string;
    hasError: boolean;
}
